<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousVendorView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Vendor Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-row>
            <b-col md="3">
              <md-layout md-flex="100">
                <label for="selectVendor">Select Vendor Type</label>
                <model-list-select
                  :list="VendorTypeList"
                  v-model="refuelDetail.selectVendorType"
                  option-value="VendorTypeVal"
                  option-text="VendorTypeText"
                  placeholder="Select Vendor Type "
                ></model-list-select>
              </md-layout>
              <span class="error" v-if="!refuelDetail.selectVendorType">{{refuelError5}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>Vendor Name</label>
                <b-form-input :formatter="capitalizeAll" id="vendorName" name="vendorName" v-model="refuelDetail.vendorName"></b-form-input>
              </md-layout>
              <span class="error" v-if="!refuelDetail.vendorName">{{refuelError}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>GST No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="gstIn"
                  name="gstIn"
                  v-model="refuelDetail.gstIn"
                  @keyup="GSTNErrorValid1()"
                ></b-form-input>
              </md-layout>
              <span class="error">{{GSTNErrorValid}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>PAN No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="panNo"
                  name="panNo"
                  v-model="refuelDetail.panNo"
                  @keyup="PANErrorValid1()"
                ></b-form-input>
              </md-layout>
              <span class="error">{{PANErrorValid}}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <md-layout md-flex="100">
                <label for="companyType">Type of Company</label>
                <model-list-select
                  :list="companyTypeList"
                  v-model="refuelDetail.companyType"
                  option-value="companyTypeVal"
                  option-text="companyTypeText"
                  placeholder="Select Company Type"
                ></model-list-select>
              </md-layout>
              <span class="error" v-if="!refuelDetail.companyType">{{companyTypeError}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>Contact Person Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="contactPersonName"
                  name="contactPersonName"
                  v-model="refuelDetail.contactPersonName"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!refuelDetail.contactPersonName">{{refuelError3}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>Contact Number</label>
                <b-form-input :formatter="capitalizeAll"
                  id="contactNumber"
                  name="contactNumber"
                  v-model="refuelDetail.contactNumber"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!refuelDetail.contactNumber">{{refuelError4}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>Email-Id</label>
                <b-form-input :formatter="capitalizeAll" id="emailId" name="emailId" v-model="refuelDetail.emailId"></b-form-input>
              </md-layout>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <md-layout md-flex="100">
                <label>Vendor Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="vendorAddress"
                  name="vendorAddress"
                  v-model="refuelDetail.vendorAddress"
                ></b-form-textarea>
              </md-layout>
              <span class="error" v-if="!refuelDetail.vendorAddress">{{refuelError2}}</span>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col md="12">
                  <md-layout md-gutter class="mt-2">
                    <md-layout md-flex="10" style="min-width:30%">
                      <span style="margin-top: 0;">Composite:</span>
                    </md-layout>
      
                    <md-layout md-flex="10" style="min-width:20%">
                      <md-radio
                        id="Composite1"
                        name="Composite1"
                        md-value="Yes"
                        v-model="refuelDetail.Composite"
                        class="md-primary margn-0px"
                      >Yes</md-radio>
                    </md-layout>
      
                    <md-layout md-flex="10" style="min-width:20%">
                      <md-radio
                        id="Composite2"
                        name="Composite2"
                        v-model="refuelDetail.Composite"
                        md-value="No"
                        class="md-primary margn-0px"
                      >No</md-radio>
                    </md-layout>
                  </md-layout>
                </b-col>
                <b-col md="12">
                  <md-layout md-gutter class="mt-2">
                    <md-layout md-flex="10" style="min-width:30%">
                      <span style="margin-top: 0;">Regular:</span>
                    </md-layout>
      
                    <md-layout md-flex="10" style="min-width:20%">
                      <md-radio
                        id="Regular"
                        name="Regular"
                        md-value="Yes"
                        v-model="refuelDetail.Regular"
                        class="md-primary margn-0px"
                      >Yes</md-radio>
                    </md-layout>
      
                    <md-layout md-flex="10" style="min-width:20%">
                      <md-radio
                        id="Regular2"
                        name="Regular"
                        v-model="refuelDetail.Regular"
                        md-value="No"
                        class="md-primary margn-0px"
                      >No</md-radio>
                    </md-layout>
                  </md-layout>
                </b-col>
                <b-col md="12">
                  <md-layout md-gutter class="mt-2">
                    <md-layout md-flex="10" style="min-width:30%">
                      <span style="margin-top: 0;">RCM:</span>
                    </md-layout>
      
                    <md-layout md-flex="10" style="min-width:20%">
                      <md-radio
                        id="RCM"
                        name="RCM"
                        md-value="Yes"
                        v-model="refuelDetail.RCM"
                        class="md-primary margn-0px"
                      >Yes</md-radio>
                    </md-layout>
      
                    <md-layout md-flex="10" style="min-width:20%">
                      <md-radio
                        id="RCM2"
                        name="RCM2"
                        v-model="refuelDetail.RCM"
                        md-value="No"
                        class="md-primary margn-0px"
                      >No</md-radio>
                    </md-layout>
                  </md-layout>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-card-text>

            <md-layout md-gutter class="mt-2">
              <md-layout md-flex="5"></md-layout>
              

              <md-layout md-flex="30"></md-layout>
            </md-layout>

            <md-layout md-gutter class="mt-2">
              <md-layout md-flex="5"></md-layout>
              

              <md-layout md-flex="30"></md-layout>
            </md-layout>

            <md-layout md-gutter class="mt-2">
              <md-layout md-flex="5"></md-layout>
              

              <md-layout md-flex="30"></md-layout>
            </md-layout>

            <md-layout md-gutter class="mt-2">
              <!-- <md-layout md-flex="90"></md-layout> -->
              <md-layout class="justify-content-center">
                <b-button variant="primary" @click="addRefuelStation" id="addButtonLoader">Save</b-button>
                <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vendorMaster/vendorMaster");
      if (globalPermissionStatus("VendorMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("VendorMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }

      if (
        this.$sessionsStorage.get("editRefuelId") != "" &&
        this.$sessionsStorage.get("editRefuelId") != undefined
      ) {
        this.viewEditRefuel();
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      alert: {
        content:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      VendorTypeList: [
        {
          VendorTypeVal: "Refueling_Station",
          VendorTypeText: "Refueling Station"
        },
        {
          VendorTypeVal: "Maintenance",
          VendorTypeText: "Maintenance"
        }
      ],

      companyTypeList: [
        {
          companyTypeVal: "Propreitorship",
          companyTypeText: "Propreitorship"
        },
        {
          companyTypeVal: "Partnership",
          companyTypeText: "Partnership"
        },
        {
          companyTypeVal: "privateLimited",
          companyTypeText: "Private Limited"
        },
        {
          companyTypeVal: "publicLimited",
          companyTypeText: "Public Limited"
        },
        {
          companyTypeVal: "HUF",
          companyTypeText: "HUF"
        }
      ],
      refuelDetail: {
        refuelStationId: "",
        vendorName: "",
        vendorAddress: "",
        selectVendorType: "",
        gstIn: "",
        panNo: "",
        tinNo: "",
        contactPersonName: "",
        contactNumber: "",
        emailId: "",
        companyType: "",
        RCM: "",
        Regular: "",
        Composite: ""
      },

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "New"
      },

      validate: true,
      refuelError: "",
      refuelError1: "",
      refuelError2: "",
      refuelError3: "",
      refuelError4: "",
      refuelError5: "",
      companyTypeError: "",
      GSTNErrorValid: "",
      PANErrorValid: ""
    };
  },

  mounted() {
    // this.JqueryFun();
  },
  beforeDestroy() {
    this.$sessionsStorage.set("editRefuelId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect
  },
  computed: {},
  methods: {
    JqueryFun() {
      return $(function() {
        return $("#vehicleMaster").DataTable();
      });
    },
    onClose(type) {
      this.$router.push({
        path: "/vendorMaster/viewVendorMaster"
      });
    },
    previousVendorView() {
      this.$router.push({
        path: "/vendorMaster/viewVendorMaster"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    validateRefuelStation() {
      let validate_new = true;
      var gstinformat = new RegExp(
        "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
      );
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

      if (this.refuelDetail.vendorName == "") {
        $("#vendorName").focus();
        this.refuelError = "Enter Vendor Name";
        validate_new = false;
      }
      if (this.refuelDetail.companyType == "") {
        $("#companyType").focus();
        this.companyTypeError = "Select Contract Type";
        validate_new = false;
      }
      if (this.refuelDetail.vendorAddress == "") {
        $("#vendorAddress").focus();
        this.refuelError2 = "Enter Vendor Address";
        validate_new = false;
      }
      // if (this.refuelDetail.panNo == "") {
      //   $("#panNo").focus();
      //   this.refuelError1 = "Enter PAN No.";
      //   validate_new = false;
      // }
      // if (this.refuelDetail.contactPersonName == "") {
      //   $("#contactPersonName").focus();
      //   this.refuelError3 = "Enter Contact Person";
      //   validate_new = false;
      // }
      // if (this.refuelDetail.contactNumber == "") {
      //   $("#contactNumber").focus();
      //   this.refuelError4 = "Enter Contact Number";
      //   validate_new = false;
      // }
      if (this.refuelDetail.selectVendorType == "") {
        $("#selectVendorType").focus();
        this.refuelError5 = "Select Vendor Type";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addRefuelStation() {
      this.validateRefuelStation();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addVendorMaster.php`,
          data: JSON.stringify(this.refuelDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            if ((result.data.msg = "Inserted Successfully")) {
              Object.keys(this.refuelDetail).map(x => {
                this.refuelDetail[x] = "";
              });
            }

            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
          })

          .catch(error => {});
      }
    },
    GSTNErrorValid1() {
      var gstinformat = new RegExp(
        "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
      );

      if (gstinformat.test(this.refuelDetail.gstIn)) {
        this.GSTNErrorValid = "";
        // console.log("qweeeee");
      } else {
        this.GSTNErrorValid = "Please Enter Valid GSTN";
      }
    },
    PANErrorValid1() {
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

      if (paninformat.test(this.refuelDetail.panNo)) {
        this.PANErrorValid = "";
        // console.log("qweeeee");
      } else {
        this.PANErrorValid = "Please Enter Valid PAN No.";
      }
    },

    viewEditRefuel() {
      let edit_Driver = {
        edit: "edit",
        refuelStationId: this.$sessionsStorage.get("editRefuelId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewEditVendorMaster.php`,
        data: JSON.stringify(edit_Driver),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            Object.keys(this.refuelDetail).map(x => {
              this.refuelDetail[x] = data.editDriver[0][x] || "";

              // this.viewEditClientDetail = data.editClient;
              //  console.log("fsf",data.truckSizeDetails)
            });
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// vendorMaster.vue?7119df74